var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"app-link",attrs:{"href":_vm.link,"target":"_blank"}},[_c('Icon',{attrs:{"path":"app","name":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }